"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Title = require("../Title");
var _RichText = require("../RichText");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Text = function Text(props) {
  var content = props.content,
    className = props.className,
    maxLines = props.maxLines,
    title = props.title,
    _props$block = props.block,
    block = _props$block === void 0 ? true : _props$block,
    _props$shouldHandleDa = props.shouldHandleDateVariable,
    shouldHandleDateVariable = _props$shouldHandleDa === void 0 ? false : _props$shouldHandleDa,
    previewMockData = props.previewMockData,
    handleVariableShow = props.handleVariableShow,
    handleVariableHide = props.handleVariableHide;
  var Wrapper = block ? 'div' : 'span';
  var processedContent = handleVariable(content, {
    shouldHandleDateVariable: shouldHandleDateVariable,
    previewMockData: previewMockData
  });
  var ref = (0, _react.useRef)(null);
  var haveVariable = shouldHandleDateVariable && handleVariableShow && handleVariableHide; // 是否处理 tfe 变量

  (0, _react.useEffect)(function () {
    // tfe 变量绑定事件
    if (haveVariable) {
      var _ref$current;
      var stringVariableContainerDom = ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelectorAll(".".concat(_RichText.STRING_VARIABLE_CONTAINER_CLASS));
      stringVariableContainerDom === null || stringVariableContainerDom === void 0 ? void 0 : stringVariableContainerDom.forEach(function (ele) {
        var _ele$firstElementChil, _ele$lastElementChild;
        (_ele$firstElementChil = ele.firstElementChild) === null || _ele$firstElementChil === void 0 ? void 0 : _ele$firstElementChil.addEventListener('mouseover', handleVariableShow);
        (_ele$lastElementChild = ele.lastElementChild) === null || _ele$lastElementChild === void 0 ? void 0 : _ele$lastElementChild.addEventListener('mouseout', handleVariableHide);
      });
    }
    return function () {
      if (haveVariable) {
        var _ref$current2, _ref$current2$querySe;
        ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : (_ref$current2$querySe = _ref$current2.querySelectorAll(".".concat(_RichText.STRING_VARIABLE_CONTAINER_CLASS))) === null || _ref$current2$querySe === void 0 ? void 0 : _ref$current2$querySe.forEach(function (ele) {
          var _ele$firstElementChil2, _ele$lastElementChild2;
          (_ele$firstElementChil2 = ele.firstElementChild) === null || _ele$firstElementChil2 === void 0 ? void 0 : _ele$firstElementChil2.removeEventListener('mouseover', handleVariableShow);
          (_ele$lastElementChild2 = ele.lastElementChild) === null || _ele$lastElementChild2 === void 0 ? void 0 : _ele$lastElementChild2.removeEventListener('mouseout', handleVariableHide);
        });
      }
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('text'), className, (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)("text-ellipsis".concat(block ? '' : '-inline', "-").concat(maxLines)), maxLines && maxLines > 0))
  }, title && /*#__PURE__*/_react.default.createElement(_Title.Title, title), /*#__PURE__*/_react.default.createElement("span", {
    ref: ref,
    dangerouslySetInnerHTML: {
      __html: processedContent
    }
  }));
};
exports.Text = Text;
var variableStringReg = /\{variable:([^;\s"&?}]*),\s*name:([^}]*)}/;
var dateVariableStringReg = /\{variable:([^;\s"&?}]*),\s*name:([^}]*),\s*dateFormat:([^}]*)}/;
var handleVariable = function handleVariable(content, _ref) {
  var _list, _list2, _list3;
  var shouldHandleDateVariable = _ref.shouldHandleDateVariable,
    previewMockData = _ref.previewMockData;
  if (!shouldHandleDateVariable) {
    return content;
  }
  var list = dateVariableStringReg.exec(content); // 先看是不是  date 类型的变量

  if (!((_list = list) !== null && _list !== void 0 && _list.length) || (_list2 = list) !== null && _list2 !== void 0 && _list2.length && ((_list3 = list) === null || _list3 === void 0 ? void 0 : _list3.length) < 2) {
    var _list4, _list5, _list6;
    list = variableStringReg.exec(content); // 在看是不是 字符串类型的变量

    if (!((_list4 = list) !== null && _list4 !== void 0 && _list4.length) || (_list5 = list) !== null && _list5 !== void 0 && _list5.length && ((_list6 = list) === null || _list6 === void 0 ? void 0 : _list6.length) < 2) {
      return content;
    }
  }
  var _list7 = list,
    _list8 = (0, _slicedToArray2.default)(_list7, 3),
    matchText = _list8[0],
    variable = _list8[1],
    name = _list8[2];
  if (!(previewMockData !== null && previewMockData !== void 0 && previewMockData[variable])) {
    return content;
  }
  var result = content.replace(matchText, function () {
    var text = "<span>{".concat(name, "}</span>").concat(previewMockData[variable] ? "<span class=\"date-text ".concat(_RichText.HIDE_CLASS, "\">").concat(previewMockData[variable], "</span>") : '');
    return "<span class=\"".concat(_RichText.STRING_VARIABLE_CONTAINER_CLASS, "\">").concat(text, "</span>");
  });
  return result;
};